<mat-card>
  <mat-card-header>
    <img
      src="{{ serviceProfileURL$ | async }}"
      mat-card-avatar
      ngClass.xs="avatar-xs"
      class="card-image"
    />
    <mat-card-title>{{ service.service.title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content
    fxLayout="column"
    fxLayoutAlign="center stretch"
    fxLayoutGap="12px"
    *ngIf="contacts$ | async as contacts; else loading"
  >
    <app-service-contact-conversation-preview
      [contact]="contact"
      *ngFor="let contact of contacts"
    ></app-service-contact-conversation-preview>
  </mat-card-content>
</mat-card>

<ng-template #loading>
  <app-loading-spinner
    class="results-spinner"
    [show]="true"
  ></app-loading-spinner
></ng-template>
